import React, { useState, useEffect } from "react";
import { fetchData } from "../../../utils/functions"; // Import your fetchData function
import { formatCount } from "../../../utils/numberFormat";

const SummaryTable = () => {
  const [districtData, setDistrictData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // Fetch district data on component mount using fetchData
  useEffect(() => {
    const fetchDistrictData = async () => {
      try {
        // Make API call using fetchData function
        const response = await fetchData(
          "districts", // API endpoint
          "GET", // HTTP method
          null, // Body (not needed for GET)
          {}, // Headers (if any)
          {}, // Params (if any)
          null, // Navigate function (if any)
          "/districts", // Redirect path (if needed)
          null // Dispatch function (if using Redux)
        );

        // Set the fetched district data to state
        setDistrictData(response?.data || {});
      } catch (err) {
        setError(err.message);
        console.error("Error fetching district data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDistrictData(); // Call the function on component mount
  }, []); // Empty dependency array ensures this runs only once

  // Render loading state or error message
  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-700"></div>
        <p className="mt-2 text-gray-600">Loading district data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  // Slice the first 2 districts
  const districtsToShow = Object.entries(districtData).slice(0, 2);

  return (
    <div className="text-center mb-3">
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
        Summary of Applications Received
      </h3>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="px-4 py-3 text-left text-white font-medium bg-[#c19a0f]">
                District
              </th>
              <th className="px-4 py-3 text-center text-white font-medium bg-[#e0b621]">
                Total Received
              </th>
              <th className="px-4 py-3 text-center text-white font-medium bg-[#f4cc40]">
                Qualified
              </th>
              <th className="px-4 py-3 text-center text-white font-medium bg-[#a07f0a]">
                Not Qualified
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {districtsToShow.length > 0 ? (
              districtsToShow.map(([district, data], index) => (
                <tr
                  key={district}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#F6F7F9" : "#FFFFFF",
                  }}
                  className="hover:bg-gray-100 transition-colors"
                >
                  <td className="px-4 py-3 text-gray-800 border-b border-gray-200">
                    {district}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-800 border-b border-gray-200">
                    {formatCount(data?.total)}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-800 border-b border-gray-200">
                    {formatCount(data?.qualified)}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-800 border-b border-gray-200">
                    {formatCount(data?.notQualified)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-8 text-center text-gray-500 border-b border-gray-200"
                >
                  No data available
                </td>
              </tr>
            )}
            {/* Total Row */}
            <tr style={{ backgroundColor: "#FEF3C7" }} className="font-bold">
              <td className="px-4 py-3 font-bold text-gray-800 border-b border-gray-200">
                Total
              </td>
              <td className="px-4 py-3 text-center text-gray-800 border-b border-gray-200">
                {formatCount(districtData?.total || 0)}
              </td>
              <td className="px-4 py-3 text-center text-gray-800 border-b border-gray-200">
                {formatCount(districtData?.qualified || 0)}
              </td>
              <td className="px-4 py-3 text-center text-gray-800 border-b border-gray-200">
                {formatCount(districtData?.notQualified || 0)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SummaryTable;
